import { useEffect, useState } from "react"
import { HiOutlineChevronUp } from "react-icons/hi"
import PropTypes from "prop-types"
import { backtoTopLabels } from "@/utils/footerUtils"
import Styles from "./index.module.scss"

export default function BackToTop({ topHeight, localeProp = "" }) {
  const handleScrollToTop = () => {
    window.scrollTo({ top: topHeight, behavior: "smooth" })
  }
  const [top, setTop] = useState(true)

  useEffect(() => {
    const scrollHandler = () => {
      window.scrollY < 500 ? setTop(false) : setTop(true)
    }
    window.addEventListener("scroll", scrollHandler)
    return () => window.removeEventListener("scroll", scrollHandler)
  }, [top])
  return (
    <>
      <button
        className={`fixed bottom-[80px] right-[40px] hidden md:block md:bottom-[60px] md:right-[65px] rounded shadow w-[56px] h-[56px] bg-[#dbdbdb] cursor-pointer pt-[2px] transition-opacity duration-500 ${top ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}
        onClick={handleScrollToTop}
      >
        <div className="font-bold text-[#232323] flex justify-center">
          <HiOutlineChevronUp size={30} />
        </div>
        <div className="text-[8px] font-[helveticaBold,_Helvetica,_sans-serif] font-[600] text-[#232323] text-center">
          {backtoTopLabels[localeProp]}
        </div>
      </button>
      <div
        className={`${Styles.backTopWrapper} koh-back-top block md:hidden transition-opacity duration-500 ${top ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}
      >
        <button style={{ display: "inline-block" }} onClick={handleScrollToTop}>
          <span className="icon"></span>
          {backtoTopLabels[localeProp]}
        </button>
      </div>
    </>
  )
}

BackToTop.propTypes = {
  topHeight: PropTypes.number,
  localeProp: PropTypes.string,
}
